module.exports = __webpack_public_path__ + "img/bug02.90933744.jpg";